"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const POOL_TYPES = {
    RECOMMENDED: "RECOMMENDED",
    FAVOURITED: "FAVOURITED",
    BLACKLISTED: "BLACKLISTED",
};
exports.default = POOL_TYPES;
